"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _pragma = require("../../../pragma");

var React = _interopRequireWildcard(require("react"));

var _ = require("../..");

var css = _interopRequireWildcard(require("./OptionChainPutTable.style"));

var _OptionChainScrollShadow = _interopRequireDefault(require("../OptionChain/OptionChainScrollShadow"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const OptionChainPutTable = ({
  handlePutScroll,
  scrollPutRef,
  putScrolledLeft,
  putScrolledRight,
  spotPuts = [],
  strikePuts = [],
  columnProps,
  putRef,
  putScrollOffset,
  hoverPutPosition,
  showLegend,
  rightTableLegend,
  putScroll,
  setScrollSource,
  scrollSource
}) => {
  const {
    showAsk = true,
    showBid = true,
    showIV = true,
    showLTP = true,
    showOI = true,
    showVolume = true
  } = columnProps;
  React.useLayoutEffect(() => {
    hoverPutPosition();
  }, []);
  const colGroup = (0, _pragma.createFelaElement)("colgroup", null, [showAsk, showBid, showIV, showLTP, showOI, showVolume
  /* eslint-disable-next-line react/no-array-index-key */
  ].map((renderColumn, i) => renderColumn ? (0, _pragma.createFelaElement)("col", {
    key: i
  }) : null));
  const putHeaderColumns = [showLTP && 'LTP & change', showAsk && 'Ask price & qty', showBid && 'Bid price & qty', showIV && 'IV(%)', showVolume && 'Volume', showOI && 'OI (lakhs)'];

  const handleMouseMove = newSource => {
    if (scrollSource !== newSource) {
      setScrollSource(newSource);
    }
  };

  const tableIndicator = 'table';
  const headerIndicator = 'header';
  return (0, _pragma.createFelaElement)("div", {
    css: css.quadrantWrapper
  }, (0, _pragma.createFelaElement)(_OptionChainScrollShadow.default, {
    activeLeft: putScrolledLeft,
    activeRight: putScrolledRight
  }), (0, _pragma.createFelaElement)(_.View, {
    alignItems: "center",
    css: css.scrollBarRow,
    gap: "xsmall",
    flexDirection: "row-reverse",
    justifyContent: "flex-start",
    padding: "xsmall"
  }, (0, _pragma.createFelaElement)(_.Text, {
    css: css.scrollLegend,
    children: rightTableLegend,
    color: "text.negative",
    variant: "metaBold"
  }), (0, _pragma.createFelaElement)("div", {
    id: "putScroll",
    css: css.scroll,
    onScroll: handlePutScroll,
    onMouseMove: () => handleMouseMove(headerIndicator),
    ref: scrollPutRef
  }, (0, _pragma.createFelaElement)(_.View, {
    id: "putScrollWidth",
    css: css.putScroll
  }))), (0, _pragma.createFelaElement)("div", {
    css: css.defaultOptionScroll,
    ref: putRef,
    onScroll: putScroll,
    onMouseMove: () => handleMouseMove(tableIndicator)
  }, (0, _pragma.createFelaElement)(_.Table, {
    borderSpacing: "none",
    css: css.dataTable,
    padding: "xsmall",
    stickyHeader: true,
    variant: "optionChain"
  }, (0, _pragma.createFelaElement)(_.TableHead, null, (0, _pragma.createFelaElement)(_.TableRow, {
    padding: ['medium', 'xsmall'],
    css: css.headerRow
  }, putHeaderColumns.map((label, i) => {
    if (label) {
      /* eslint-disable react/no-array-index-key */
      return (0, _pragma.createFelaElement)(_.TableCell, {
        key: i,
        align: "right"
      }, (0, _pragma.createFelaElement)(_.Text, {
        children: label,
        variant: "meta",
        truncate: true
      }));
      /* eslint-enable */
    }

    return undefined;
  })), (0, _pragma.createFelaElement)(_.TableRow, {
    css: css.scrollTableRow
  }, (0, _pragma.createFelaElement)(_.TableCell, null)), showLegend && (0, _pragma.createFelaElement)(_.TableRow, {
    css: css.legendRow
  }, (0, _pragma.createFelaElement)(_.TableCell, null))), colGroup, (0, _pragma.createFelaElement)(_.TableBody, null, strikePuts.map((row, i) => (0, _pragma.createFelaElement)(_.OptionChainRow, _extends({}, row, columnProps, {
    key: i // eslint-disable-line react/no-array-index-key
    ,
    call: false,
    scrollOffset: putScrollOffset
  }))), (0, _pragma.createFelaElement)(_.TableRow, {
    css: css.strikeTableRow
  }, (0, _pragma.createFelaElement)(_.TableCell, null)), spotPuts.map((row, i) => (0, _pragma.createFelaElement)(_.OptionChainRow, _extends({
    key: i // eslint-disable-line react/no-array-index-key

  }, row, columnProps, {
    call: false,
    highlight: true,
    scrollOffset: putScrollOffset
  })))))));
};

OptionChainPutTable.displayName = 'OptionChainPutTable';
var _default = OptionChainPutTable;
exports.default = _default;
//# sourceMappingURL=OptionChainPutTable.js.map